/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type Assessment from '@linc-technologies/linced-common/models/assessments/assessment';
import type GradeSchedule from '@linc-technologies/linced-common/models/assessments/grade-schedule';
import type Person from '@linc-technologies/linced-common/models/person';
import type School from '@linc-technologies/linced-common/models/school';

// Proto: assessments.Module.
export default class Module extends Model {
  declare [Type]: 'assessments/module';

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @attr('string', { defaultValue: '' })
  declare campusId: string; // TODO: implement when we have Campuses

  @belongsTo('person', { async: true, inverse: null })
  declare authorId: AsyncBelongsTo<Person>;

  @alias('authorId')
  declare author: AsyncBelongsTo<Person>;

  @attr('number')
  declare updateTime: number | undefined;

  @attr('number')
  declare createTime: number | undefined;

  @attr('boolean', { defaultValue: false })
  declare isLocked: boolean;

  @attr('string', { defaultValue: '' })
  declare templateId: string; // TODO: implement once Templates are added

  @belongsTo('assessments/assessment', { async: true, inverse: 'modules' })
  declare assessmentId: AsyncBelongsTo<Assessment>;

  @alias('assessmentId')
  declare assessment: AsyncBelongsTo<Assessment>;

  @attr('number', { defaultValue: 0 })
  declare sequence: number;

  @attr('string', { defaultValue: '' })
  declare label: string;

  @attr('string', { defaultValue: '' })
  declare description: string;

  @attr('number')
  declare type: number | undefined;

  @attr('string', { defaultValue: '' })
  declare key: string;

  @belongsTo('assessments/grade-schedule', { async: true, inverse: null })
  declare gradeScheduleId: AsyncBelongsTo<GradeSchedule>;

  @alias('gradeScheduleId')
  declare gradeSchedule: AsyncBelongsTo<GradeSchedule>;

  @alias('gradeSchedule.id')
  declare gradeSchedule_id: string | null | undefined;

  @attr('boolean', { defaultValue: false })
  declare isModerated: boolean;

  @attr('number', { defaultValue: 0 })
  declare numericStepping: number;

  @attr('number', { defaultValue: 0 })
  declare dueTime: number;
}
